const getEnvironment = () => {
  const isLocalhost = window.location.hostname.includes('localhost');
  const isPreview = window.location.hostname.includes('preview');
  const isDev = isLocalhost || isPreview;
  return { isDev, isPreview, isLocalhost };
};

export default getEnvironment;
